import { createSelector } from 'reselect';

import productsRequireValidate from './getProductsCartRequireValidate';

const getCartItemsRequireValidate = createSelector(
  productsRequireValidate,
  p => {
    if (p.length > 0) {
      return p;
    }
    return [];
  },
);

export default getCartItemsRequireValidate;
